import { LoginArea as BaseLoginArea } from './auth/LoginArea';

export function LoginArea() {
  return <BaseLoginArea className="max-w-60" />;
}